<template>
  <div>
    <div style="height:60px;"></div>
    <div class="mtop">
      <!-- 手机端分类顶部 -->
      <el-row>
        <el-col :span="6">
          <i class="el-icon-arrow-left f16"></i>
          <span class="text-color f14" @click="$router.back(-1)">返回</span>
        </el-col>
        <el-col class="top-title" :span="12">{{title}}</el-col>
        <el-col :span="6">{{tab}}</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "MTop",
  props: ["title", "tab"]
};
</script>

<style scoped lang="scss">
.mtop {
  position: fixed;
  top: 0px;
  z-index: 2000;
  width: 100%;
  height: 60px;
  line-height: 60px;
  color: #000;
  background-color: #fff;
  text-align: center;
  border-bottom: 1px solid #dddddd;
  .el-icon-arrow-left {
    color: #2697eb;
  }
  .top-title {
    font-size: 20px;
    font-weight: bold;
  }
}

.text-color {
  color: #2697eb;
}
</style>


// WEBPACK FOOTER //
// src/components/top/mtop.vue